<!--
Author: TangChen
Date: 2018-10-08
Desc: 手机号码绑定，由index.js 配置引入
 -->
<template>
    <div class="bizcomp-change-mobile">
        <my-dialog
            class="my-dialog-contain"
            title="修改手机号码"
            :visible="visible"
            width="620px"
            :dialog-close="dialogClose"
        >
            <div v-if="!checked" class="acct-con">
                <div class="check-acct">
                    <el-form
                        ref="pwdForm"
                        :model="pwdForm"
                        :rules="rules"
                        inline-message
                        v-on:submit.native.prevent
                    >
                        <el-form-item label="新手机号码：" prop="mobileno" class="form-text">
                            <el-select
                                v-model="mobileNoCode"
                                class="select-mobile-Code"
                                placeholder="请选择手机号码国家码"
                                :disabled="true"
                            ></el-select>
                            <el-input
                                v-model.trim="pwdForm.mobileno"
                                :placeholder="plaC"
                                :maxlength="11"
                                class="input-mobile"
                            />
                        </el-form-item>
                        <el-form-item label="手机验证码：" prop="verifyCode" class="verifycode-row">
                            <el-input
                                v-model.trim="pwdForm.verifyCode"
                                class="verifycode-style"
                                placeholder="请输入手机验证码"
                                :maxlength="6"
                            ></el-input>
                            <span class="get-verify" :disabled="time > 0" v-on:click="mobileCheck">
                                {{ btnMsg }}
                            </span>
                        </el-form-item>
                        <el-form-item>
                            <div class="btn-contain">
                                <button class="cancel-btn" v-on:click="dialogClose">取消</button>
                                <button class="confirm-btn" v-on:click="submitForm('pwdForm')">
                                    确定
                                </button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div v-else class="change-phone-result">
                <div class="result-contain">
                    <div class="result-img-contain">
                        <img src="../../assets/img/success.png" alt="" />
                    </div>
                    <div class="result-text">更换手机号码成功!</div>
                </div>
                <div class="result-confirm-contain">
                    <button class="result-confirm" v-on:click="dialogClose">确定</button>
                </div>
            </div>
        </my-dialog>
        <img-code
            :dialog-visible="dialogVisible"
            :biztype="$const.IMG_BIZTYPE.CHANGEMOBILE"
            v-on:verify-in="getVerifyCode"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import imgCode from "@/components/layout/imgCode.vue";
import userApi from "@/api/user";
import myDialog from "@/components/layout/myDialog.vue";

export default {
    name: "ChangeMobile",
    components: {
        imgCode,
        myDialog
    },
    mixins: [mixin],
    props: {
        modifytype: {
            type: String,
            default: () => {
                return "1";
            }
        }
    },
    data() {
        return {
            mobileNoCode: "中国 + 86",
            visible: true,
            time: 0, // 验证码再次发送间隔
            pwdForm: {
                // 表单参数配置
                mobileno: "",
                verifyCode: "",
                pwd: ""
            },
            info: {},
            dialogVisible: false,
            btnMsg: "获取验证码",
            plaC: "请输入新手机号",
            locked: false, // 是否已发送短信验证码
            checked: false,
            rules: {
                // 校验规则
                mobileno: [
                    {
                        message: "请输入手机号码",
                        trigger: "blur"
                    },
                    { validator: this.mobileno, trigger: "blur" }
                ],
                verifyCode: [
                    {
                        validator: this.$util.validateVerifyCode,
                        trigger: "blur"
                    }
                ]
            },
            resultMes: {
                // 结果页面信息
                cla: "register-success",
                msg: "您已成功绑定登录手机为",
                btnL: {
                    text: "返回首页",
                    event: "login-now"
                },
                btnR: {
                    ctd: "秒后自动跳转个人中心",
                    time: 10,
                    event: "return-login"
                }
            }
        };
    },
    created() {
        this.info = this.$cache.getUser();
    },
    methods: {
        dialogClose() {
            this.visible = false;
            this.$emit("change-dialog-close", false);
        },
        /* 提交表单数据,校验手机验证码 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.locked) {
                        this.$message({
                            type: "warning",
                            message: "请先发送手机短信验证码"
                        });
                        return false;
                    }
                    this.checkVerifyCode();
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 获取验证码
        sendCode() {
            if (this.time > 0) return;
            if (this.$cache.getSysParam("10103010") == "2") {
                this.getVerifyCode("1");
            } else {
                this.dialogVisible = true;
            }
        },
        /* 密码表单回调数据 */
        async pwdOk() {
            const data = {
                mobileno: this.pwdForm.mobileno.replace(/\s/g, ""),
                originmobileno: this.info.mobileno,
                smscode: this.pwdForm.verifyCode,
                biztype: this.$const.IMG_BIZTYPE.CHANGEMOBILE,
                modifytype: this.modifytype
            };

            const res = await userApi.modifyMobile(data);

            if (res.code === "0") {
                this.checked = true;
                this.$cache.refreshUser();
                this.resultMes.msg += this.pwdForm.mobileno;
            }
        },
        // 校验手机号
        mobileno(rule, value, callback) {
            if (value === this.info.mobileno) {
                callback();
            } else {
                this.$util.validateMobile(rule, value, callback);
            }
        },
        /* 提交表单数据 */
        mobileCheck() {
            let _this = this;
            this.$refs.pwdForm.validateField("mobileno", function (str) {
                if (str === "") {
                    _this.sendCode();
                } else {
                    return false;
                }
            });
        },
        /* 校验手机验证码 */
        checkVerifyCode() {
            this.pwdOk();
        },
        /* 获取图形验证码值 */
        async getVerifyCode(val) {
            if (!val) {
                this.dialogVisible = false;
                return;
            }
            if (val || this.$cache.getSysParam("10103010") == "2") {
                const res = await userApi.sendSms({
                    mobileno: this.pwdForm.mobileno,
                    biztype: this.$const.IMG_BIZTYPE.CHANGEMOBILE,
                    verifycode: val
                });
                if (res.code === "0") {
                    /* 倒计时 */
                    this.dialogVisible = false;
                    this.time = res.data.sendperiod;
                    this.locked = true;
                    this.$util.btnDisabled(this);
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg
                    });
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-change-mobile {
    .acct-con {
        padding: 40px 40px 20px;
        :deep(.el-form-item) {
            margin: 0;
        }
        :deep(.el-form-item__error--inline) {
            margin-left: 90px;
        }
        .form-text {
            margin-bottom: 23px;
            .select-mobile-Code {
                width: 130px;
            }
            .input-mobile {
                width: 276px;
                margin-left: 10px;
            }
        }
        .verifycode-row {
            font-size: 14px;
            font-weight: normal;
            color: #333333;
            .verifycode-style {
                position: relative;
                width: 416px;
                border-radius: 2px;
                background: #ffffff;
                box-sizing: border-box;
                border: 1px solid #d9d9d9;
            }
            .get-verify {
                position: absolute;
                right: 50px;
                font-size: 16px;
                font-weight: normal;
                cursor: pointer;
                color: #e60012;
            }
        }
        .tips-row {
            padding-left: 90px;
            .tips-text {
                height: 20px;
                font-size: 14px;
                font-weight: normal;
                line-height: 20px;
                color: #999999;
            }
            .tips-to-text {
                margin-left: 6px;
                height: 20px;
                font-size: 14px;
                font-weight: normal;
                color: #1890ff;
            }
        }
        .btn-contain {
            margin-top: 33px;
            text-align: center;
            .cancel-btn {
                padding: 10px 0;
                width: 180px;
                border-radius: 2px;
                background: #e4e4e4;
                font-size: 16px;
                font-weight: 500;
                color: #666666;
                border: 1px solid #e4e4e4;
                cursor: pointer;
            }
            .confirm-btn {
                margin-left: 40px;
                padding: 10px 0;
                width: 180px;
                border-radius: 2px;
                background: #e60012;
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
                border: 1px solid #e60012;
                cursor: pointer;
            }
        }
        .warn-tip {
            padding: 25px 30px 30px 0;
            .tip-title {
                font-size: 16px;
                font-weight: normal;
                color: #666666;
                line-height: normal;
            }
            .tip-text {
                font-size: 14px;
                font-weight: normal;
                color: #666666;
                line-height: normal;
            }
        }
    }
    .change-phone-result {
        text-align: center;
        .result-text {
            font-size: 26px;
            margin-top: 24px;
            font-weight: 500;
            color: #333333;
        }
    }
    .result-contain {
        width: 590px;
        margin: auto;
        margin-top: 40px;
        background: hsl(0, 0%, 98%);
        height: 242px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .result-confirm-contain {
        text-align: center;
        margin-top: 30px;
        .result-confirm {
            cursor: pointer;
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: #e60012;
            border: 1px solid #e60012;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
        }
    }
    .margin-10 {
        margin: 10px 0;
    }
    .color-e60012 {
        color: #e60012;
    }
}
</style>
